/* eslint-disable import/no-default-export */
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls';
// eslint-disable-next-line no-restricted-imports
import { State, toggleBoardStar } from 'modules';

// eslint-disable-next-line no-restricted-imports
import { isBoardStarred } from 'selectors';

import styles from './board-buttons.less';
import { BoardHeaderButton } from './button';

// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
const format = forTemplate('board_list_item');

interface StarredBoardButtonProps {
  readonly idBoard: string;
  readonly isStarred: boolean;
  onClick(): void;
}

class StarredBoardButton extends React.Component<StarredBoardButtonProps> {
  render() {
    const { isStarred, onClick }: StarredBoardButtonProps = this.props;

    return (
      <BoardHeaderButton
        className={isStarred ? styles.yellowStar : ''}
        icon={IconName.Star}
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }}
        tabIndex={-1}
        title={format(
          'click-to-star-this-board-it-will-show-up-at-top-of-your-boards-list',
        )}
      />
    );
  }
}

const mapStateToProps = (state: State, ownProps: StarredBoardButtonProps) => {
  const { idBoard } = ownProps;

  return {
    isStarred: isBoardStarred(state, idBoard),
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch<State>,
  ownProps: StarredBoardButtonProps,
) => {
  const { idBoard } = ownProps;

  return {
    onClick() {
      dispatch(toggleBoardStar({ idBoard }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StarredBoardButton);



// WEBPACK FOOTER //
// ./app/gamma/src/components/board-buttons/starred-board-button.tsx